import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b779a51"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "footer",
  class: "footer"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "info" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "客服咨询：", -1 /* HOISTED */))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "010-53655900", -1 /* HOISTED */))
const _hoisted_6 = { class: "info" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "邮件咨询：", -1 /* HOISTED */))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "market@galaxy-future.com", -1 /* HOISTED */))
const _hoisted_9 = { class: "info" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "联系地址：", -1 /* HOISTED */))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "北京市海淀区知春路23号", -1 /* HOISTED */))
const _hoisted_12 = { class: "channel" }
const _hoisted_13 = { class: "qr" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "客服咨询", -1 /* HOISTED */))
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "qr" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "微信视频号", -1 /* HOISTED */))
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "qr" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "微信小程序", -1 /* HOISTED */))
const _hoisted_21 = ["src"]
const _hoisted_22 = { class: "record" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PhoneOutlined = _resolveComponent("PhoneOutlined")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_MailOutlined = _resolveComponent("MailOutlined")!
  const _component_EnvironmentOutlined = _resolveComponent("EnvironmentOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_popover = _resolveComponent("a-popover")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_Link = _resolveComponent("Link")!
  const _component_a_list_item = _resolveComponent("a-list-item")!
  const _component_a_list = _resolveComponent("a-list")!
  const _component_Footer = _resolveComponent("Footer", true)!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("footer", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_a_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, {
              xs: 24,
              sm: 12,
              md: 10,
              lg: 12,
              order: _ctx.$Store.Public().isGridMatch('>=',_ctx.$Enum.GridEnum.SM)?1:2
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_3, [
                          _createVNode(_component_PhoneOutlined, { rotate: 90 }),
                          _hoisted_4,
                          _hoisted_5
                        ])
                      ]),
                      _: 1 /* STABLE */
                    }),
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, [
                          _createVNode(_component_MailOutlined),
                          _hoisted_7,
                          _hoisted_8
                        ])
                      ]),
                      _: 1 /* STABLE */
                    }),
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_9, [
                          _createVNode(_component_EnvironmentOutlined),
                          _hoisted_10,
                          _hoisted_11
                        ])
                      ]),
                      _: 1 /* STABLE */
                    }),
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_12, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.expand.icon, (item) => {
                            return (_openBlock(), _createBlock(_component_a_popover, null, {
                              content: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.title), 1 /* TEXT */)
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_a_button, {
                                  type: "link",
                                  target: "_blank",
                                  href: item.href
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", {
                                      class: _normalizeClass(["iconfont", `icon-${item.name}`])
                                    }, null, 2 /* CLASS */)
                                  ]),
                                  _: 2 /* DYNAMIC */
                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["href"])
                              ]),
                              _: 2 /* DYNAMIC */
                            }, 1024 /* DYNAMIC_SLOTS */))
                          }), 256 /* UNKEYED_FRAGMENT */))
                        ])
                      ]),
                      _: 1 /* STABLE */
                    }),
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_col, {
                              xs: 12,
                              lg: 8
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_13, [
                                  _hoisted_14,
                                  _createElementVNode("img", {
                                    src: $data.file.ImageQR_3,
                                    alt: "客服咨询"
                                  }, null, 8 /* PROPS */, _hoisted_15)
                                ])
                              ]),
                              _: 1 /* STABLE */
                            }),
                            _createVNode(_component_a_col, {
                              xs: 12,
                              lg: 8
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_16, [
                                  _hoisted_17,
                                  _createElementVNode("img", {
                                    src: $data.file.ImageQR_4,
                                    alt: "微信视频号"
                                  }, null, 8 /* PROPS */, _hoisted_18)
                                ])
                              ]),
                              _: 1 /* STABLE */
                            }),
                            _createVNode(_component_a_col, {
                              xs: 12,
                              lg: 8
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_19, [
                                  _hoisted_20,
                                  _createElementVNode("img", {
                                    src: $data.file.ImageQR_5,
                                    alt: "微信小程序"
                                  }, null, 8 /* PROPS */, _hoisted_21)
                                ])
                              ]),
                              _: 1 /* STABLE */
                            }),
                            _createCommentVNode("<a-col :xs=\"12\" :sm=\"24\" :md=\"12\">"),
                            _createCommentVNode("    <div class=\"qr\">"),
                            _createCommentVNode("        <span>微信公众号</span>"),
                            _createCommentVNode("        <img :src=\"file.ImageQR_1\" alt=\"微信公众号\" />"),
                            _createCommentVNode("    </div>"),
                            _createCommentVNode("</a-col>"),
                            _createCommentVNode("<a-col :xs=\"12\" :sm=\"24\" :md=\"12\">"),
                            _createCommentVNode("    <div class=\"qr\">"),
                            _createCommentVNode("        <span>微信开源群</span>"),
                            _createCommentVNode("        <img :src=\"file.ImageQR_2\" alt=\"微信开源群\" />"),
                            _createCommentVNode("    </div>"),
                            _createCommentVNode("</a-col> ")
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["order"]),
            _createVNode(_component_a_col, {
              class: "box_list",
              xs: 24,
              sm: {offset:1,span:11},
              md: {offset:1,span:13},
              lg: {offset:0,span:12},
              order: _ctx.$Store.Public().isGridMatch('>=',_ctx.$Enum.GridEnum.SM)?2:1
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_row, {
                  justify: _ctx.$Store.Public().isGridMatch('>=',_ctx.$Enum.GridEnum.LG)?'start':'start'
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.expand.list, (v, index) => {
                      return (_openBlock(), _createBlock(_component_a_col, {
                        key: index,
                        span: _ctx.$Store.Public().isGridMatch('>=',_ctx.$Enum.GridEnum.LG)?6:_ctx.$Store.Public().isGridMatch('<',_ctx.$Enum.GridEnum.LG)?24:12
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", {
                            class: "list",
                            style: _normalizeStyle({ marginLeft: _ctx.$Store.Public().isGridMatch('>=',_ctx.$Enum.GridEnum.LG)?  index === 'plan' ? '30px' : '20px':'0px' })
                          }, [
                            _createElementVNode("h2", null, _toDisplayString(v.name), 1 /* TEXT */),
                            _createVNode(_component_a_list, {
                              "data-source": v.list,
                              split: false
                            }, {
                              renderItem: _withCtx(({ item }) => [
                                _createVNode(_component_a_list_item, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Link, {
                                      name: item.name,
                                      href: item.href+(item.hash?`#${item.hash}`:'')
                                    }, null, 8 /* PROPS */, ["name", "href"])
                                  ]),
                                  _: 2 /* DYNAMIC */
                                }, 1024 /* DYNAMIC_SLOTS */)
                              ]),
                              _: 2 /* DYNAMIC */
                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["data-source"])
                          ], 4 /* STYLE */)
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["span"]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["justify"])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["order"])
          ]),
          _: 1 /* STABLE */
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createVNode(_component_Footer)
    ])
  ], 64 /* STABLE_FRAGMENT */))
}